import manifestReducer from '@ey/voltron-core/manifest-reducer';
import reducerManifest from './manifest.js';
import Env from '../util/env.js';

import {
	GAMLayerWithCountryLanguageReducer,
	UIActionReducer,
	canvasFormCountriesReducer,
	canvasFormLanguagesReducer,
	canvasFormTypesReducer,
	serviceLinesReducer
} from './CanvasForm/canvasformreducer';
import {
	accountAssertionsReducer,
	accountDetailsReducer,
	accountsEditReducer,
	accountsReducer,
	currentAccountReducerSEM
} from './Accounts/accountsreducer';
import {accountCRAReducer} from './Accounts/accountcrareducer';
import accountsReducerAccountList from './Accounts/accountsreduceraccountList.js';
import {assertionsReducer, engagementAssertionsReducer, riskWcgwSelectionReducer} from './Assertions/assertionsreducer';
import assignmentReducer, {manageAssignmentReducer} from './Assignment/assignmentReducer';
import {associateTaskToggleReducer, copyhubPackageDetailsReducer} from './CopyHub/copyhubpackagedetailsreducer';
import {
	buildtasksReducer,
	taskRelatedUnrelatedEntitiesReducer,
	taskListPreparerCountReducer,
	taskListReducer,
	taskListReducerForWCGW,
	taskListUnassignedReducer
} from './task/tasklistreducer';
import {glAccountReducer} from './TrialBalance/glaccountreducer.js';
import canvasFormReportReducer, {controlFormReportReducer} from './Reporting/canvasFormReportReducer';
import {
	clientGroupReducer,
	clientGroupsReducer,
	createClientGroupCounterReducer,
	validateAllDomainsReducer
} from './ManageTeam/clientgroupsreducer';
import {
	contentupdatesReducer,
	pspAccountsReducer,
	syncContentUpdatesReducer
} from './ContentUpdates/contentupdatesreducer';
import {
	copyhubSuccessMessageReducer,
	copyhubErrorMessageReducer,
	createPackageReducer
} from './CopyHub/createPackageReducer';
import {
	engagementAccessLocationReducer,
	engagementIndependenceUsersReducer,
	engagementMetaDataReducer,
	engagementReducer,
	engagementUsersWithRoles
} from './Engagements/engagementreducer';
import externalUsersReducer, {externalUserReducer} from './ManageTeam/externalusersreducer';
import {formBodyDataReducer, formDataReducer, formDisplayDataBodyReducer} from './FormData/formdatareducer';
import {getReviewNotesAuthoredByCountReducer, reviewNotesCountReducer} from './ReviewNotes/reviewnotescountreducer';
import independenceReducer, {independenceResponsesReducer} from './Independence/independencereducer';
import internalUsersReducer, {
	internalUserRbacRoleReducer,
	internalUserReducer
} from './ManageTeam/internalusersreducer';
import {relatedRisksReducer, risksReducer, wcgwRelatedRisksReducer, riskListReducer} from './Risk/riskreducer';
import rolesReducer, {rbacUserRolesReducer} from './MasterData/rolesReducer';
import {validationCountsReducer, validationDetailsReducer} from './ValidationControl/validationcontrolreducer';

import ConnectivityStateReducer from './connectivitystatereducer';
import CommonReviewNoteHubFilterReducer from './ReviewNoteHub/commonrnhfilterreducer';
import createHelixProjectReducer from './HelixProjects/createhelixprojectreducer';
import EPEQRTasksDocSignOffCount from './task/epeqrtaskssignoffcountreducer';
import GAInstructionsReducer from './GAInstructions/GAInstructionsReducer';
import GAScopesReducer from './GAScopes/GAScopesReducer';
import GASelectTeamsReducer from './DashBoardV2/GroupAudit/gaselectteamsreducer';
import GATasksReducer from './GATasks/GATasksReducer';
import GSScopesLinkRequestReducer from './GSScopesLinkRequest';
import GSScopesReducer from './GSScopes/GSScopesReducer';
import GSSnapshotsReducer from './GSSnapshots';
import GetActiveProjectsReducer from './HelixProjects/getactiveprojectsreducer';
import GetHandoffReducer from '../../src/components/Common/HandOff/Reducers/handoffreducer';
import GetHandoffUsersReducer from './task/handoffusersreducer';
import GetProjectsReducer from './HelixProjects/getprojectsreducer';
import HandOffTaskDocumentReducer from './task/handofftaskdocumentreducer';
import HandOffTaskDocumentsReducer from '../../src/components/Common/HandOff/Reducers/handofftaskdocumentreducer';
import LinkedProjectsReducer from './HelixProjects/linkedprojectsreducer';
import PICEQRReviewNoteHubFilterReducer from './ReviewNoteHub/piceqrreviewnotehubfilterreducer';
import ReceiveInstructionsReducer from './ReceiveInstructions';
import ReviewNoteHubFilterReducer from './ReviewNoteHub/reviewnotehubfilterreducer';
import ReviewNoteHubReducer from './ReviewNoteHub/reviewnotehubreducer';
import TaskListGroupReducer from './task/tasklistgroupreducer';
import VersionUpgradeStateReducer from './versionreducer';
import activityFeedReducer from './ActivityFeed/activityfeedreducer';
import addDocumentReviewNoteReducer from './ReviewNotes/adddocumentreviewnotereducer';
import addDocumentToTaskReducer from './task/adddocumenttotaskreducer';
import addDocumentToTaskValidationReducer from './task/adddocumenttotaskvalidationreducer';
import addTaskReviewNoteReducer from './ReviewNotes/addtaskreviewnotereducer';
import addclientRequestDocumentsReducer from './ClientRequest/ClientRequestDocuments/addclientRequestDocumentsReducer';
import appOnlineStateReducer from './apponlinestatereducer';
import arcChecksListReducer from './ArcTimeline/arccheckslistreducer';
import arcValidationReducer from './ArcTimeline/arcvalidationsreducer';
import archiveEngagementReducer from './ArcTimeline/archivereducer';
import assignmentsReducer from '../../src/components/Common/HandOff/Reducers/assignmentreducer';
import auditphaseMilestoneDetailsReducer from './Milestone/auditphasemilestonedetailsreducer';
import milestoneDetailsReducer from './Milestone/milestonedetailsreducer';
import automationRequestReducer from './AutomationRequest/automationRequestReducer';
import automationServiceTimeoutReducer from './task/automationservicetimeoutreducer';
import bulkAssignmentToastsReducer from './BulkAssignment/bulkassignmenttoastsreducer';
import bulkTaskAssignToTypeReducer from './task/bulktaskassigntotypereducer';
import bulkTaskListFiltersReducer from './task/bulktasklistfiltersreducer';
import bulkTaskSeeTaskReducer from './task/bulktaskseetaskreducer';
import bulkfilterdatareducer from './Filter/bulkfilterdatareducer';
import bulkfilterreducer from './Filter/bulkfilterreducer';
import bulkquickfilterreducer from './Filter/bulkquickfilterreducer';
import canEnableAndDisplayMarkCompleteAssignmentReducer from './task/canenableanddisplaymarkcompleteassignmentreducer';
import canvasFormChildDocumentsReducer from './task/canvasFormChildDocumentsreducer';
import canvasFormRelatedObjectsReducer from './CanvasForm/canvasformrelatedobjectsreducer';
import canvasFormRelatedTasksReducer from './CanvasForm/canvasformrelatedtasksreducer';
import canvasFormToSendValidationReducer from './task/canvasformtosendvalidationreducer';
import canvasFormUpdateFiltersReducer from './ContentUpdates/canvasformupdatefiltersreducer';
import {canvasFormUpdatesReducer} from './ContentUpdates/canvasformupdatesreducer';
import changeTaskStatusReducer from './task/changetaskstatusreducer';
import {commonClientRequestCustomFiltersReducer} from './ClientRequest/commonClientReqCustomFilterReducer';
import {clientRequestAdvancedSearchOptionsReducer} from './ClientRequest/clientRequestAdvancedSearchOptionsReducer';
import {clientRequestAssignedToReducer} from './ClientRequest/clientRequestAssignedToReducer';
import clientRequestCommentReducer from './ClientRequest/clientRequestCommentReducer';
import {clientRequestCustomFiltersReducer} from './ClientRequest/clientRequestCustomFilterReducer';
import clientRequestDetailReducer from './ClientRequest/clientRequestDetailReducer';
import clientRequestDocumentsReducer from './ClientRequest/ClientRequestDocuments/clientRequestDocumentsReducer';
import {clientRequestEYContactsReducer} from './ClientRequest/clientRequestEYContactsReducer';
import clientRequestFilterReducer from './ClientRequest/clientRequestFilterReducer';
import {clientRequestFollowersReducer} from './ClientRequest/clientRequestFollowersReducer';
import clientRequestReducer from './ClientRequest/clientRequestReducer';
import clientRequestRemoveCustomFilterReducer from './ClientRequest/clientRequestRemoveCustomFilterReducer';
import clientRequestSetupReducer from './ClientRequest/clientRequestSetupReducer';
import clientRequestTagsReducer from './ClientRequest/clientRequestTagsReducer';
import {clientRequestToastMessageReducer} from './ClientRequest/clientRequestToastMessageReducer';
import clientRequestsSummaryReducer from './ClientRequest/clientRequestsSummaryReducer';
import collaborationRequestsReducer from './task/collaborationrequestsreducer';
import confidentialityTypesReducer from './MasterData/confidentialityTypesReducer';
import configurationsReducer from './Configurations/configurationsreducer';
import contentTypeReducer from './MasterData/contentTypeReducer';
import {controlReducer} from './Control/controlreducer.js';
import copyhubPackageFileSizeReducer from './CopyHub/copyhubpackagefilesizereducer';
import copyhubPackagesReducer from './CopyHub/copyhubpackagesreducer';
import countryStatusReducer from './task/countrystatusreducer';
import createPaperProfileReducer from './task/createpaperprofilereducer';
import createTaskReducer from './task/createtaskreducer';
import createdTaskDetailsReducer from './task/createdtaskdetailsreducer';
import createdocumentcopyreducer from './task/createdocumentcopyreducer';
import dashboardGAContextReducer from './DashBoardV2/GroupAudit/dashboardcontextreducer';
import dashboardGADocumentsReducer from './DashBoardV2/GroupAudit/dashboardgadocumentsreducer';
import dashboardGroupAuditReducer from './DashBoardV2/GroupAudit/dashboardgroupauditreducer';
import deficienciesReducer from './Deficiencies/deficienciesreducer';
import docHelperDocuments from './Documents/docHelperDocumentsReducer';
import documentChangeTypesReducer from './documentChangeTypes';
import documentDownloadReducer from './Documents/documentDownloadReducer';
import documentExtensionReducer from './Documents/documentExtensionReducer';
import documentListReducer from './Documents/documentListReducer';
import documentGlAccountUploadCountReducer from './Documents/documentGlAccountUploadCountReducer';
import documentNameReducer from './task/documentnamereducer';
import documentReducer from './task/documentreducer';
import documentSettingConfigurationReducer from './ClientRequest/ClientRequestDocuments/documentSettingConfigurationReducer';
import documentsReducer from './Documents/documentsreducer';
import duplicateDocumentsReducer from './Documents/duplicateDocumentsReducer';
import engagementAssignmentsReducer from './task/engagementassignmentsreducer';
import engagementITProcessesReducer from './task/itprocessesreducer';
import engagementMapReducer from './Maps/engagementmapreducer.js';
import engagementMembersReducer from './task/engagementmembersreducer';
import engagementProfileReducer from './Engagements/engagementprofilereducer';
import engagementScotsReducer from './task/scotsreducer';
import engagementTeamMembersReducer from './task/engagementteammembersreducer';
import engagementtagsreducer from './Tags/engagementtagsreducer';
import engagementTagGroupsReducer from './Tags/engagementTagGroupsReducer.js';
import glAccountAssociatedTagsReducer from './Tags/glAccountAssociatedTagsReducer.js';
import errorReducer, {hideGlobalErrorToastReducer} from './errorreducer';
import eventReducer from './task/eventreducer';
import executiveDashboardReducer from './DashBoardV2/PICEQRDashboard/executiveDashboardReducer';
import existingtemporarydocumentreducer from './task/existingtemporarydocumentreducer';
import filterOptionsReducer from './task/filteroptionsreducer';
import filterdatareducer from './Filter/filterdatareducer';
import filterreducer from './Filter/filterreducer';
import fourFortyGlDocumentsReducer from './Documents/fourFortyGlDocumentsReducer';
import {gaTeamsReducer} from './GAComponents/gaComponentsReducer';
import getDocumentReviewNoteStatusFilterReducer from './ReviewNotes/getdocumentreviewnotestatusfilterreducer';
import getHandOffTasksReducer from './task/gethandofftasksreducer';
import getMarkCompleteTasksReducer from './task/getmarkcompletetasksreducer';
import getOtherEngagementsReviewNotesCountReducer from './task/getotherengagementsreviewnotescountreducer';
import getPicEqrDocumentsCountForExecutiveReview from './DashBoardV2/ExecutiveReview/executivereviewcountsreducer';
import getTaskGroupsSectionsReducer from './task/gettaskgroupssectionsreducer';
import getTaskReviewNoteStatusFilterReducer from './ReviewNotes/gettaskreviewnotestatusfilterreducer';
import getdescriptionsreducer from './task/getdescriptionsreducer';
import globalStateReducer from './globalstatereducer';
import {groupAuditScopesReducer} from './GroupAuditTasks/groupAuditScopesReducer';
import {groupAuditTasksReducer} from './GroupAuditTasks/groupAuditTasksReducer';
import {groupTaskFilterReducer} from './GroupAuditTasks/groupTaskFilterReducer';
import gsScopesSendVersionReducer from './GSScopesSendVersion';
import instructionReducer from './Instruction/instructionReducer';
import isAssignmentMarkedForCompletionReducer from './task/isassignmentmarkedforcompletionreducer';
import isCurrentResourceAvailableReducer from './iscurrentresourceavailablereducer';
import isMultiSelectTaskReducer from './task/ismultiselecttasksreducer';
import isPreparerAssignmentExistReducer from './task/isPreparerAssignmentExistReducer';
import mediaPlayingReducer from './MediaPlaying/mediaplayingreducer.js';
import manageTeamBehaviourReducer from './ManageTeam/manageteambehaviourreducer';
import mileStoneReducer from './task/milestonereducer';
import milestoneBuildTasks from './task/milestonebuildtaskreducer';
import misstatementsReducer from './Misstatements/misstatementsreducer';
import {modalOpenStateReducer, ADCModalOpenStateReducer, modalLevelStateReducer} from './task/modalopenstatereducer';
import multiSelectTaskReducer from './task/multiselecttasksreducer';
import myWorkspaces from './workspacesreducer';
import noteDetailsReducer from './ReviewNoteHub/rnhnotedetailreducer';
import offlinePrepReducer from './offlineprepreducer';
import oversightAllProjectsReducer from '../components/Common/EngagementReport/reducer/oversightAllProjectReducer';
import oversightOtherProjectreducer from '../components/Common/EngagementReport/reducer/oversightOtherProjectreducer';
import oversightProjectreducer from '../components/Common/EngagementReport/reducer/oversightProjectreducer';
import overwriteDocumentsReducer from './Overwrite/overwritedocumentsreducer';
import paansreducer from './Paans/paansreducer';
import piceqrDocumentListReducer from './Documents/piceqrDocumentListReducer';
import piceqrTaskFilterReducer from './task/pictaskfilterreducer';
import popUpToastMessageReducer from './PopUpToastMessage/popUpToastMessageReducer';
import {priorPeriodUsersReducer} from './ManageTeam/priorperiodusersreducer';
import pspIndexesReducer from './PSPIndexes/pspIndexesReducer';
import {quickLinkReducer} from './Milestone/QuickLinks/quicklinksreducer';
import referenceDocumentsReducer from './Documents/referenceDocumentsReducer';
import rejectTaskReducer, {acceptTaskReducer} from './task/taskreducers.js';
import relatedDocumentsReducer from './task/relatedDocumentsReducer';
import relatedFindingsReducer from './task/relatedfindingsreducer';
import relatedWCGWsReducer from './Risk/relatedwcgwsreducer';
import relatetaskautomationreducer from './task/relatetaskautomationreducer';
import reloadDataBannerReducer from './DashBoardV2/PICEQRDashboard/reloadDataBannerReducer';
import reportReducer from './Reporting/reportreducer';
import reviewNoteCategoryrReducer from './ReviewNotes/reviewnotecatogeryreducer';
import reviewNoteDocumentReducer from './ReviewNotes/reviewnotedocumentreducer';
import reviewNotesReducer from './ReviewNotes/reviewnotesreducer';
import risktypereducer from './RiskType/risktypereducer';
import rnhFilterOptionsReducer from './ReviewNoteHub/rnhfilteroptionsreducer';
import rnhisbulkselectionreducer from './ReviewNoteHub/rnhisbulkselectionreducer';
import rnhmultipleselectionreducer from './ReviewNoteHub/rnhmultipleselectionreducer';
import scotsReducer from './Scots/scotsreducer';
import selectedNoteIdReducer from './ReviewNoteHub/rnhselectednoteidreducer';
import selectedTaskReducer from './task/selectedtaskreducer';
import serviceOfferingsReducer from './ServiceOfferings/serviceOfferingsReducer';
import serviceRequestDetailReducer from './ServiceRequest/servicerequestdetailreducer';
import serviceRequestReducer from './ServiceRequest/serviceRequestreducer';
import serviceRequestsReducer from './ServiceRequest/serviceRequestsreducer';
import setTaskListViewReducer from './task/tasklistviewreducer';
import signOffsReducer from './task/signoffsreducer';
import {sortTableReducer} from './ClientRequest/sortTableReducer';
import sortingPropsReducer from './DynamicList/sortingpropsreducer';
import statusAssigmentReducer from '../../src/components/Common/HandOff/Reducers/taskassignmentsreducer';
import statusAssigmentsReducer from './task/taskassignmentsstatusreducer';
import syncStateReducer from './syncstatereducer';
import taskAssignmentsReducer from './task/taskassignmentsreducer';
import taskCategoriesReducer from './task/taskcategoriesreducer';
import taskDeleteReducer from './task/taskdeletereducer';
import taskDescriptionReducer from './task/taskdescriptionreducer';
import taskDetailReducer from '../../src/components/Common/HandOff/Reducers/taskdetailsreducer';
import taskDetailsReducer from './task/taskdetailsreducer';
import taskDocumentSelectorReducer from './task/taskdocumentselectorreducer';
import taskDocumentTabReducer from './task/taskdocumenttabreducer';
import taskDocumentsReducer from './task/taskdocumentsreducer';
import taskGuidanceReducer from './task/taskguidancereducer';
import taskListFiltersReducer from './task/tasklistfiltersreducer';
import taskRelatedEntitiesReducer from './task/taskrelatedentitiesreducer';
import taskRelatedItemReducer from './task/taskrelateditemreducer';
import taskRelatedObjectReducer from './task/taskrelatedobjectreducer';
import taskRelatedServiceRequestsReducer from './task/taskrelatedservicerequestsreducer';
import taskReviewersReducer from './task/taskreviewersreducer';
import taskServiceOfferingsReducer from './ServiceOfferings/taskServiceOfferingsReducer';
import taskServiceRequestsReducer from './ServiceRequest/taskServiceRequestsreducer';
import taskStatusAssigmentsReducer from '../../src/components/Common/HandOff/Reducers/taskassignmentsstatusreducer';
import taskSubCategoriesReducer from './task/tasksubcategoriesreducer';
import taskTagsReducer from './Tags/tasktagsreducer';
import taskWcgwReducer from './task/taskwcgwreducer';
import taskdocumentrelatereducer from './task/taskdocumentrelatereducer';
import tasksViewReducer from './DashBoardV2/PICEQRDashboard/tasksViewReducer';
import timePhasesReducer from './task/timephasesreducer';
import {timeoutReducer} from './timeoutReducer';
import uiFilterReducer from './Engagements/uifiltersreducer';
import uploadTaskDocumentsReducer from './task/uploadtaskdocumentsreducer';
import userPreferencesReducer from './userpreferences/userpreferencesreducer';
import userPresenceReducer from './UserPresence/userpresencereducer';
import userSearchReducer from './UserSearch/usersearchreducer';
import userSettings from './usersettingsreducer';
import viewInstructionsReducer from './DashBoardV2/GroupAudit/viewinstructionsreducer';
import {wcgwReducer, wcgwAddUpdateReducer} from './WCGW/wcgwreducer.js';
import wcgwTasksScotsreducer from './Scots/wcgwTaskScotsreducer';
import workspaceEngagementsReducer from './task/workspaceengagementsreducer';
import estimatesReducer from './Estimate/estimatereducer';
import {stEntityReducer, taskSTEntityReducer} from './STEntity/stentityreducer';
import drillDownEntityDetailsReducer from './DashBoardV2/drillDownEntityDetailsReducer';
import materialityReducer from './DashBoardV2/materialityreducer';
import multiEntityDashboardReducer from './DashBoardV2/MultiEntityDashboard/multiEntityDashboardReducer';
import drillDownTimePhaseReducer from './DashBoardV2/MultiEntityDashboard/drillDownTimePhaseReducer';
import {trialBalanceReducer} from './TrialBalance/trialbalancereducer';
import {financialStatementReducer} from './FinancialStatement/financialstatementreducer';
import {financialStatementByIdReducer} from './FinancialStatement/financialstatementbyidreducer';
import financialStatementFiltersReducer from './FinancialStatement/financialStatementFiltersReducer';
import quickAccessDocumentReducer from './DashBoardV2/MultiEntityDashboard/quickAccessDocumentReducer';
import hasScopeAndStrategyGuidedWorkflowReducer from './DashBoardV2/MultiEntityDashboard/hasScopeAndStrategyGuidedWorkflowReducer';
import verticalNavigationReducer from './BuildStepsV2/verticalNavigationReducer.js';
import {itAppSOReducer} from './ITAppSO/itappsoreducer.js';
import knowledgeDataReducer from './MasterData/knowledgedatareducer.js';
import {itcontrolReducer} from './ITControl/itcontrolreducer.js';
import BulkRequestSeeRequest from './ClientRequest/Bulk/bulkrequestseerequestreducer.js';
import taskSectionReducer from './task/tasksectionreducer.js';
import UpchunkUploadReducer from './upchunkUploadReducer.js';
import {bulkRequestFiltersReducer} from './ClientRequest/Bulk/bulkRequestFiltersReducer.js';
import {bulkRequestSearchReducer} from './ClientRequest/Bulk/bulkRequestSearchReducer.js';
import bulkRequestSelectedReducer from './ClientRequest/Bulk/bulkRequestSelectedReducer';
import {setFormV2ToasterVisibilityReducer} from './Toast/toastreducer';
import glAccountsNotesReducer from './Notes/glaccountnotesreducer';
import notesReducer from './GLAccount/notesreducer';
import groupInstructionReducer from './GroupInstruction/groupInstructionReducer.js';
import AIChatBotIntegrationParametersReducer from './IntegrationParameter/AIChatBotIntegrationParametersReducer.js';
import HelixProjectFilterMetadataReducer from './HelixProjects/helixprojectfiltermetadatareducer.js';
import HelixProjectGLAAccountdataReducer from './HelixProjects/getglaccountstatusreducer.js';
import UserValidationWithHelixProjectReducer from './HelixProjects/uservalidationwithhelixprojectreducer.js';
import MappedEntitiesreducer from './HelixProjects/mappedentitiesreducer.js';
import globalNavReducer from './globalNavReducer.js';
import myProgressCollaborationStatsReducer from './ClientRequest/myProgressCollaborationStatsReducer.js';
import {validationsReducer} from './validations/validationsreducer.js';
import helixAnalyzerMaxConnectionReachedReducer from './HelixProjects/helixanalyzermaxconnectionreachedreducer.js';
import {adobeAnalytics} from '@ey/voltron-analytics';
import helixMultiEntityReducer from './HelixProjects/helixmultientityreducer.js';

/*
	manifestReducer will only run the reducers needed for any particular action.
	This is achieved by the `npm run compile:reducer-manifest`command, which will
	scan the reducers' code at build-time and generate a manifest that maps actions
	to the reducer function that actually process it.

	By knowing ahead of time what actions map to what reducers, performance can improve
	a lot (in Hercules, as much as 200x per action dispatch), and it won't be necessary
	to classify reducers into routes.

	During deployments, this manifest generation will happen as part of the build,
	but during development, you might want to run `npm run compile:reducer-manifest`
	for every new reducer function, action type or even switch cases inside existing
	reducers to make sure your new logic is run when dispatching store actions. Any
	changes to the manifest must be commited; otherwise, other developers might get
	obscure, store-related bugs when they pull changes.
*/
export default manifestReducer(
	{
		_taskDocuments: uploadTaskDocumentsReducer,
		accountAssertions: accountAssertionsReducer,
		accountDetails: accountDetailsReducer,
		accountValidationCount: accountCRAReducer,
		accounts: accountsReducer,
		accountsEdit: accountsEditReducer,
		accountList: accountsReducerAccountList,
		activeProjects: GetActiveProjectsReducer,
		activityFeed: activityFeedReducer,
		addclientRequestDocuments: addclientRequestDocumentsReducer,
		addDocumentToTask: addDocumentToTaskReducer,
		apponlinestate: appOnlineStateReducer,
		appVersion: VersionUpgradeStateReducer,
		arcChecksList: arcChecksListReducer,
		archiveEngagement: archiveEngagementReducer,
		arcValidations: arcValidationReducer,
		assertions: assertionsReducer,
		assignment: assignmentsReducer,
		assignments: assignmentReducer,
		associateTaskToggle: associateTaskToggleReducer,
		auditphaseMilestoneDetails: auditphaseMilestoneDetailsReducer,
		auditphaseMilestoneDetailsForExecutiveReview: getPicEqrDocumentsCountForExecutiveReview,
		milestoneDetailsForDashboard: milestoneDetailsReducer,
		automationRequest: automationRequestReducer,
		automationServiceTimeout: automationServiceTimeoutReducer,
		buildTasks: buildtasksReducer,
		bulkAssignmentToasts: bulkAssignmentToastsReducer,
		bulkFilter: bulkfilterreducer,
		bulkFilterData: bulkfilterdatareducer,
		bulkquickfilter: bulkquickfilterreducer,
		bulkTaskAssignToType: bulkTaskAssignToTypeReducer,
		bulkTaskListFilters: bulkTaskListFiltersReducer,
		bulkTaskSeeTask: bulkTaskSeeTaskReducer,
		bulkRequestCustomFilter: bulkRequestFiltersReducer,
		bulkRequestSearchOptions: bulkRequestSearchReducer,
		bulkRequestSeeRequest: BulkRequestSeeRequest,
		bulkRequestSelected: bulkRequestSelectedReducer,
		canEnableAndDisplayMarkCompleteAssignment: canEnableAndDisplayMarkCompleteAssignmentReducer,
		canvasFormChildDocuments: canvasFormChildDocumentsReducer,
		canvasFormCountries: canvasFormCountriesReducer,
		canvasFormLanguages: canvasFormLanguagesReducer,
		canvasFormRelatedObjects: canvasFormRelatedObjectsReducer,
		canvasFormRelatedTasks: canvasFormRelatedTasksReducer,
		canvasFormReport: canvasFormReportReducer,
		canvasFormToSendValidation: canvasFormToSendValidationReducer,
		canvasFormTypes: canvasFormTypesReducer,
		canvasFormUpdateFilters: canvasFormUpdateFiltersReducer,
		canvasFormUpdates: canvasFormUpdatesReducer,
		changeTaskStatus: changeTaskStatusReducer,
		clientFollowersRelatedTasks: clientRequestFollowersReducer,
		clientGroup: clientGroupReducer,
		clientGroups: clientGroupsReducer,
		clientRequestAdvancedSearchOptions: clientRequestAdvancedSearchOptionsReducer,
		clientRequestAssignedTo: clientRequestAssignedToReducer,
		clientRequestComments: clientRequestCommentReducer,
		clientRequestDetail: clientRequestDetailReducer,
		clientRequestDocuments: clientRequestDocumentsReducer,
		clientRequestEYContacts: clientRequestEYContactsReducer,
		clientRequestFilters: clientRequestFilterReducer,
		clientRequestRemoveCustomFilterReducer: clientRequestRemoveCustomFilterReducer,
		clientRequests: clientRequestReducer,
		clientRequestsCustomFilter: clientRequestCustomFiltersReducer,
		clientRequestSetup: clientRequestSetupReducer,
		clientRequestsSummary: clientRequestsSummaryReducer,
		clientRequestTags: clientRequestTagsReducer,
		commonClientReqCustomFilter: commonClientRequestCustomFiltersReducer,
		commonRNHFilters: CommonReviewNoteHubFilterReducer,
		confidentialityTypes: confidentialityTypesReducer,
		configurations: configurationsReducer,
		connectivitystate: ConnectivityStateReducer,
		contentupdates: contentupdatesReducer,
		contentUpdateTypes: contentTypeReducer,
		controlFormReport: controlFormReportReducer,
		controls: controlReducer,
		copiedDocumentId: createdocumentcopyreducer,
		copyhubPackageDetails: copyhubPackageDetailsReducer,
		copyhubPackages: copyhubPackagesReducer,
		copyhubSuccessMessage: copyhubSuccessMessageReducer,
		copyhubErrorMessage: copyhubErrorMessageReducer,
		countryStatus: countryStatusReducer,
		createClientGroupCounter: createClientGroupCounterReducer,
		createdEngagementHelixId: createHelixProjectReducer,
		createdTaskDetails: createdTaskDetailsReducer,
		createdTaskId: createTaskReducer,
		createManualCanvasFormUIState: UIActionReducer,
		createPackageRequest: createPackageReducer,
		currentAccountSEM: currentAccountReducerSEM,
		dashboardContext: dashboardGAContextReducer,
		dashboardTaskDocuments: dashboardGADocumentsReducer,
		deficiencies: deficienciesReducer,
		docHelperDocuments: docHelperDocuments,
		document: documentReducer,
		documentChangeTypes: documentChangeTypesReducer,
		documentDownload: documentDownloadReducer,
		documentExtensions: documentExtensionReducer,
		documentList: documentListReducer,
		glAccountDocUploadCount: documentGlAccountUploadCountReducer,
		documentName: documentNameReducer,
		documentReviewNoteStatusFilter: getDocumentReviewNoteStatusFilterReducer,
		documents: documentsReducer,
		documentSettingConfiguration: documentSettingConfigurationReducer,
		drillDownEntityDetails: drillDownEntityDetailsReducer,
		drillDownTimePhases: drillDownTimePhaseReducer,
		duplicateDocuments: duplicateDocumentsReducer,
		engagement: engagementReducer,
		engagementAssertions: engagementAssertionsReducer,
		engagementAssignments: engagementAssignmentsReducer,
		engagementFileSizeInfo: copyhubPackageFileSizeReducer,
		engagementITProcesses: engagementITProcessesReducer,
		engagementMap: engagementMapReducer,
		engagementMembers: engagementMembersReducer,
		engagementMetaData: engagementMetaDataReducer,
		engagementProfiles: engagementProfileReducer,
		engagementPspAccounts: pspAccountsReducer,
		engagementScots: engagementScotsReducer,
		engagementTags: engagementtagsreducer,
		engagementTagGroups: engagementTagGroupsReducer,
		engagementTagByAccountIds: glAccountAssociatedTagsReducer,
		engagementTeamMembers: engagementTeamMembersReducer,
		engagementUsersWithRoles: engagementUsersWithRoles,
		epeqrtasksdocsignoffcounts: EPEQRTasksDocSignOffCount,
		errors: errorReducer,
		isGlobalErrorToastHidden: hideGlobalErrorToastReducer,
		estimates: estimatesReducer,
		events: eventReducer,
		executiveDashboard: executiveDashboardReducer,
		existingTemporaryDocument: existingtemporarydocumentreducer,
		externalUser: externalUserReducer,
		externalUsers: externalUsersReducer,
		filter: filterreducer,
		filterData: filterdatareducer,
		filterOptions: filterOptionsReducer,
		financialStatement: financialStatementReducer,
		financialStatementsById: financialStatementByIdReducer,
		financialStatementsFilters: financialStatementFiltersReducer,
		formBodyData: formBodyDataReducer,
		formBodyDisplayData: formDisplayDataBodyReducer,
		formData: formDataReducer,
		fourFortyGlDocuments: fourFortyGlDocumentsReducer,
		gaInstructions: GAInstructionsReducer,
		GAMLayerWithCountryLanguage: GAMLayerWithCountryLanguageReducer,
		gaScopes: GAScopesReducer,
		gaTasks: GATasksReducer,
		gaTeams: gaTeamsReducer,
		getDescriptions: getdescriptionsreducer,
		glAccounts: glAccountReducer,
		glAccountNotes: glAccountsNotesReducer,
		glNotes: notesReducer,
		globalNavState: globalNavReducer,
		globalState: globalStateReducer,
		groupAuditComponents: dashboardGroupAuditReducer,
		groupAuditScopes: groupAuditScopesReducer,
		groupAuditTasks: groupAuditTasksReducer,
		groupInstruction: groupInstructionReducer,
		groupTaskFilter: groupTaskFilterReducer,
		gsScopes: GSScopesReducer,
		gsScopesLinkRequest: GSScopesLinkRequestReducer,
		gsScopesSendVersion: gsScopesSendVersionReducer,
		gsSnapshots: GSSnapshotsReducer,
		handoff: GetHandoffReducer,
		handOffTaskDocs: HandOffTaskDocumentsReducer,
		handOffTaskDocuments: HandOffTaskDocumentReducer,
		handOffTasks: getHandOffTasksReducer,
		handoffUsers: GetHandoffUsersReducer,
		hasAccessLocation: engagementAccessLocationReducer,
		hasScopeAndStrategyGuidedWorkflow: hasScopeAndStrategyGuidedWorkflowReducer,
		helixProjects: GetProjectsReducer,
		helixProjectFilterMetadata: HelixProjectFilterMetadataReducer,
		helixProjectGLAAccountdata: HelixProjectGLAAccountdataReducer,
		helixAnalyzerMaxConnectionReached: helixAnalyzerMaxConnectionReachedReducer,
		helixMultiEntity: helixMultiEntityReducer,
		userValidationWithHelixProjectReducer: UserValidationWithHelixProjectReducer,
		mappedEntitiesReducer: MappedEntitiesreducer,
		independenceConfirmation: engagementIndependenceUsersReducer,
		independenceResponses: independenceResponsesReducer,
		independenceSummary: independenceReducer,
		instruction: instructionReducer,
		internalUser: internalUserReducer,
		internalUserRbacRoles: internalUserRbacRoleReducer,
		internalUsers: internalUsersReducer,
		isAssignmentMarkedForCompletion: isAssignmentMarkedForCompletionReducer,
		isCurrentResourceAvailable: isCurrentResourceAvailableReducer,
		isDocumentNameAlreadyExists: addDocumentToTaskValidationReducer,
		isMediaPlaying: mediaPlayingReducer,
		isModalOpen: modalOpenStateReducer,
		isADCModalOpen: ADCModalOpenStateReducer,
		modalLevel: modalLevelStateReducer,
		isMultiSelectTasks: isMultiSelectTaskReducer,
		isPreparerAssignmentExist: isPreparerAssignmentExistReducer,
		isTaskListGroup: TaskListGroupReducer,
		itApplications: itAppSOReducer,
		itControls: itcontrolReducer,
		linkedProjects: LinkedProjectsReducer,
		manageAssignments: manageAssignmentReducer,
		manageTeamBehaviour: manageTeamBehaviourReducer,
		markCompleteTasks: getMarkCompleteTasksReducer,
		materiality: materialityReducer,
		mileStone: mileStoneReducer,
		milestoneBuildTasks: milestoneBuildTasks,
		misstatements: misstatementsReducer,
		multiEntityDashboard: multiEntityDashboardReducer,
		multiSelectTasks: multiSelectTaskReducer,
		myWorkspaces: myWorkspaces,
		myProgressCollaborationStats: myProgressCollaborationStatsReducer,
		newDocumentReviewNote: addDocumentReviewNoteReducer,
		newPaperProfileId: createPaperProfileReducer,
		newTaskReviewNote: addTaskReviewNoteReducer,
		offlinePrep: offlinePrepReducer,
		otherEngagementsReviewNotes: getOtherEngagementsReviewNotesCountReducer,
		oversightAllProjects: oversightAllProjectsReducer,
		oversightotherProjects: oversightOtherProjectreducer,
		oversightProjects: oversightProjectreducer,
		overwriteDocuments: overwriteDocumentsReducer,
		paansuserdata: paansreducer,
		piceqrDocumentListFilters: piceqrDocumentListReducer,
		piceqrrnhFilters: PICEQRReviewNoteHubFilterReducer,
		picTaskListFilters: piceqrTaskFilterReducer,
		popUpToastMessage: popUpToastMessageReducer,
		priorPeriodUsers: priorPeriodUsersReducer,
		pspIndexes: pspIndexesReducer,
		quickAccessDocument: quickAccessDocumentReducer,
		quickLink: quickLinkReducer,
		rbacRoles: rbacUserRolesReducer,
		receiveInstructions: ReceiveInstructionsReducer,
		referenceDocuments: referenceDocumentsReducer,
		relatedDocuments: relatedDocumentsReducer,
		rejectTask: rejectTaskReducer,
		acceptedTask: acceptTaskReducer,
		relatedFindings: relatedFindingsReducer,
		relatedRisks: relatedRisksReducer,
		relatedWCGWs: relatedWCGWsReducer,
		relateRequests: collaborationRequestsReducer,
		relatetaskautomationreducer: relatetaskautomationreducer,
		reloadDataBanner: reloadDataBannerReducer,
		reportInfo: reportReducer,
		reviewAssignments: taskReviewersReducer,
		reviewNoteCategory: reviewNoteCategoryrReducer,
		reviewNoteDocument: reviewNoteDocumentReducer,
		reviewNotes: reviewNotesReducer,
		reviewNotesAuthoredByCount: getReviewNotesAuthoredByCountReducer,
		reviewNotesCount: reviewNotesCountReducer,
		risks: risksReducer,
		riskList: riskListReducer,
		riskTypes: risktypereducer,
		riskWcgwSelection: riskWcgwSelectionReducer,
		rnhFilterOptions: rnhFilterOptionsReducer,
		rnhFilters: ReviewNoteHubFilterReducer,
		rnhIsBulkSelection: rnhisbulkselectionreducer,
		rnhMultipleNotes: rnhmultipleselectionreducer,
		rnhNoteDetail: noteDetailsReducer,
		rnhNotes: ReviewNoteHubReducer,
		rnhSelectedNote: selectedNoteIdReducer,
		roles: rolesReducer,
		savedFilters: uiFilterReducer,
		scots: scotsReducer,
		selectedTeams: GASelectTeamsReducer,
		serviceLines: serviceLinesReducer,
		serviceOfferings: serviceOfferingsReducer,
		serviceRequest: serviceRequestReducer,
		serviceRequestDetail: serviceRequestDetailReducer,
		serviceRequests: serviceRequestsReducer,
		sessionTimer: timeoutReducer,
		signOffs: signOffsReducer,
		sortingProps: sortingPropsReducer,
		sortTable: sortTableReducer,
		statusAssigments: statusAssigmentsReducer,
		statusAssignment: statusAssigmentReducer,
		stentities: stEntityReducer,
		taskstentities: taskSTEntityReducer,
		syncContentUpdates: syncContentUpdatesReducer,
		syncState: syncStateReducer,
		taskAssignments: taskAssignmentsReducer,
		taskCategories: taskCategoriesReducer,
		taskDeleteResponse: taskDeleteReducer,
		taskDescription: taskDescriptionReducer,
		taskDetail: taskDetailReducer,
		taskDetails: taskDetailsReducer,
		taskDocumentRelate: taskdocumentrelatereducer,
		taskDocuments: taskDocumentsReducer,
		taskDocumentSelectedId: taskDocumentSelectorReducer,
		taskDocumentTab: taskDocumentTabReducer,
		taskGroupsSections: getTaskGroupsSectionsReducer,
		taskGuidance: taskGuidanceReducer,
		taskId: selectedTaskReducer,
		taskList: taskListReducer,
		taskListFilters: taskListFiltersReducer,
		taskListPreparerCount: taskListPreparerCountReducer,
		taskListView: setTaskListViewReducer,
		taskRelatedEntities: taskRelatedEntitiesReducer,
		taskRelatedItem: taskRelatedItemReducer,
		taskRelatedObject: taskRelatedObjectReducer,
		taskRelatedServiceRequests: taskRelatedServiceRequestsReducer,
		taskReviewNoteStatusFilter: getTaskReviewNoteStatusFilterReducer,
		taskServiceOfferings: taskServiceOfferingsReducer,
		taskServiceRequests: taskServiceRequestsReducer,
		taskStatusAssigments: taskStatusAssigmentsReducer,
		taskSubCategories: taskSubCategoriesReducer,
		taskRelatedUnrelatedEntities: taskRelatedUnrelatedEntitiesReducer,
		tasksUnassigned: taskListUnassignedReducer,
		tasksView: tasksViewReducer,
		taskTags: taskTagsReducer,
		taskWcgws: taskWcgwReducer,
		timePhase: timePhasesReducer,
		toastMessage: clientRequestToastMessageReducer,
		toasterDetails: setFormV2ToasterVisibilityReducer,
		trialBalances: trialBalanceReducer,
		userPreferences: userPreferencesReducer,
		userPresence: userPresenceReducer,
		userSearcheResults: userSearchReducer,
		userSettings: userSettings,
		validateAllDomains: validateAllDomainsReducer,
		validationcounts: validationCountsReducer,
		validationdetails: validationDetailsReducer,
		verticalNavigation: verticalNavigationReducer,
		viewInstructions: viewInstructionsReducer,
		wcgwRelatedRisks: wcgwRelatedRisksReducer,
		wcgws: wcgwReducer,
		wcgwDetails: wcgwAddUpdateReducer,
		wcgwTasks: taskListReducerForWCGW,
		wcgwTasksScots: wcgwTasksScotsreducer,
		workspaceEngagements: workspaceEngagementsReducer,
		knowledgeData: knowledgeDataReducer,
		taskSections: taskSectionReducer,
		mobileUpload: UpchunkUploadReducer,
		aiChatBotIntegrationParameters: AIChatBotIntegrationParametersReducer,
		validations: validationsReducer,
		adobeAnalytics: adobeAnalytics.adobeAnalyticsReducer
	},
	{
		manifest: reducerManifest,
		ignoreActions: ['HOME_LOGIN'],
		log: Env.allowDrydocks()
	}
);
